import { render, staticRenderFns } from "./CostBasedConfiguration.vue?vue&type=template&id=40253dea&scoped=true"
import script from "./CostBasedConfiguration.vue?vue&type=script&lang=js"
export * from "./CostBasedConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40253dea",
  null
  
)

export default component.exports